import React from 'react';

const TimesheetContent = () => {
    return (
        <div className="timesheet-container">
            <div className="content-section">

                {/* Heading: Addressing the Issue of Missing Timesheets */}
                <h3 style={{ fontSize: "22px", fontWeight: "500", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
                    Why Can't I See All Timesheets?
                </h3> 

                {/* Explanation of Timesheet Management */}
                <h3 className="sub-heading">
                    Understanding Timesheet Visibility and Submission Challenges
                </h3>
                <p className="description">
                    Timesheets are essential for tracking employee work hours, ensuring accurate payroll processing, and maintaining compliance with labor regulations. 
                    However, it is common for some timesheets to be missing or not visible due to various reasons, including "late submissions, approval pending status, or restricted access permissions".
                </p>

                {/* Detailed Explanation of Why Timesheets May Be Missing */}
                <h4 className="section-heading">Reasons You Might Not See All Timesheets</h4>
                <ul className="list">
                    <li>
                        <strong>Timesheets Not Yet Submitted:</strong> Employees may have forgotten to log their hours, or they could be experiencing technical difficulties. 
                        Encourage timely submissions through automated reminders.
                    </li>
                    <li>
                        <strong>Pending Manager Approval:</strong> If a timesheet is waiting for approval from a supervisor or manager, it might not appear as completed. 
                        Ensure managers review and approve timesheets on time.
                    </li>
                    <li>
                        <strong>Restricted Permissions:</strong> Some organizations have role-based access control, meaning certain employees or departments 
                        might not have visibility over all timesheets. Verify with the HR or IT department if you have the correct access level.
                    </li>
                    <li>
                        <strong>System Sync Delays:</strong> Sometimes, timesheet records take time to update due to synchronization processes in payroll or HR software. 
                        Wait for the system to refresh or contact IT support for assistance.
                    </li>
                    <li>
                        <strong>Incorrect Date Filters:</strong> If you are looking for timesheets in a specific date range, double-check the filters applied in the system. 
                        Ensure you are selecting the right pay period or project.
                    </li>
                </ul>

                {/* Best Practices for Ensuring Timesheets Are Visible */}
                <h4 className="section-heading">How to Ensure All Timesheets Are Submitted and Visible</h4>
                <ul className="list">
                    <li>
                        <strong>Enable Automatic Reminders:</strong> Set up email or system alerts to notify employees about upcoming deadlines for timesheet submissions.
                    </li>
                    <li>
                        <strong>Regularly Communicate with Team Members:</strong> Encourage open communication between employees and managers regarding timesheet policies and deadlines.
                    </li>
                    <li>
                        <strong>Review Access Permissions:</strong> Ensure that HR, payroll teams, and relevant managers have the necessary access to review all timesheets.
                    </li>
                    <li>
                        <strong>Monitor Pending Approvals:</strong> Keep track of timesheets that require approval and follow up with managers to prevent processing delays.
                    </li>
                </ul>

                {/* Final Thoughts */}
                <p className="closing-text">
                    Managing timesheets efficiently is crucial for maintaining "accurate payroll records, tracking employee productivity, and ensuring compliance". 
                    By understanding common issues and implementing best practices, organizations can streamline their "timesheet submission, approval, and review processes". 
                
                </p>

                {/* Supporting Image */}
                <img 
                    src="https://res.cloudinary.com/dvcdrb9s4/image/upload/v1737029075/Screenshot_2025-01-16_at_5.34.26_PM_v8egtt.png" 
                    alt="Timesheet Management" 
                    className="placeholder-image image_gatnix_support"
                />
            </div>
        </div>
    );
};

export default TimesheetContent;
